import type {CryptoNetwork} from './types';

const EVM_ADDRESS_REGEX = /^0x[0-9a-fA-F]{40}$/;
const SOLANA_ADDRESS_REGEX = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;
const BITCOIN_ADDRESS_REGEX =
  /^(1|3)[1-9A-HJ-NP-Za-km-z]{24,33}$|^bc1[0-9a-z]{39,59}$/;
const SUI_ADDRESS_REGEX = /^0x[0-9a-fA-F]{64}$/;
const STELLAR_ADDRESS_REGEX = /^G[A-Z2-7]{55}$/;
const TRON_ADDRESS_REGEX = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;

export const isValidCryptoAddress = (
  address: string,
  network: CryptoNetwork,
): boolean => {
  switch (network) {
    case 'arbitrum':
    case 'avalanche_c_chain':
    case 'base':
    case 'ethereum':
    case 'optimism':
    case 'polygon':
    case 'tempo':
      return EVM_ADDRESS_REGEX.test(address);
    case 'bitcoin':
      return BITCOIN_ADDRESS_REGEX.test(address);
    case 'solana':
      return SOLANA_ADDRESS_REGEX.test(address);
    case 'stellar':
      return STELLAR_ADDRESS_REGEX.test(address);
    case 'sui':
      return SUI_ADDRESS_REGEX.test(address);
    case 'tron':
      return TRON_ADDRESS_REGEX.test(address);
    default: {
      const _exhaustive: never = network;
      throw new Error(`Unexpected network: ${_exhaustive}`);
    }
  }
};
